/**
 * O valor da consulta no agendamento (#1100): ao escolher o médico e a
 * especialidade, o preço particular aparece, só para leitura. Vem do sistema da
 * clínica (`GET /v1/consultas/medicos/{id}/preco`): o do médico, ou o padrão da
 * clínica quando ele não tem preço próprio. Ninguém edita aqui; o preço muda no
 * sistema da clínica.
 *
 * Sem os preços ligados na organização, o campo não aparece.
 */

import type { ReactNode } from 'react';
import { usePrecoDaConsultaDoMedico } from '@/shared/api/consultas';
import { dinheiroComCentavos } from '@/shared/lib/formato';
import { usePreferencias } from '@/shared/sessao/contexto';
import { Campo } from '@/shared/ui';

export function ValorDaConsulta({ medicoId }: { medicoId: string }): ReactNode {
  const { clinica } = usePreferencias();
  const ligada = clinica['precos_de_consulta'] !== undefined;
  const preco = usePrecoDaConsultaDoMedico(medicoId, ligada);
  if (!ligada || medicoId === '') return null;

  const valor = preco.data?.preco ? (dinheiroComCentavos(preco.data.preco) ?? '') : '';
  const ajuda = preco.isPending
    ? 'Buscando o preço…'
    : preco.isError
      ? 'Não deu para ver o preço agora.'
      : preco.data?.origem === 'padrao'
        ? 'Particular. O padrão da clínica: o médico não tem preço próprio.'
        : preco.data?.origem === 'medico'
          ? 'Particular, deste médico.'
          : 'O sistema da clínica não tem preço para esta consulta.';

  return (
    <Campo
      id="nova-consulta-valor"
      rotulo="Valor da consulta"
      value={valor}
      placeholder="—"
      ajuda={ajuda}
      readOnly
    />
  );
}
